import React from 'react';
import './WhatsAppSupport.css';

const WhatsAppSupport = ({ variant = 'floating' }) => {
  const whatsappNumber = '254738669931';
  const defaultMessage = 'hello';
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;

  const handleClick = () => {
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  if (variant === 'header') {
    return (
      <button 
        className="whatsapp-support-btn header-btn"
        onClick={handleClick}
        title="Contact us on WhatsApp"
        aria-label="Contact support on WhatsApp"
      >
        <span className="whatsapp-icon">💬</span>
        <span className="whatsapp-text">Support</span>
      </button>
    );
  }

  // Floating button variant (default)
  return (
    <button 
      className="whatsapp-support-btn floating-btn floating-right"
      onClick={handleClick}
      title="Contact us on WhatsApp"
      aria-label="Contact support on WhatsApp"
    >
      <span className="whatsapp-icon">💬</span>
      <span className="whatsapp-text">Need Help?</span>
      <div className="pulse-ring"></div>
    </button>
  );
};

export default WhatsAppSupport;
